module.exports = __webpack_public_path__ + "img/i4.e2043158.png";